<svg
  [ngStyle]="styleList"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.5"
    y="1.5"
    width="61"
    height="61"
    [attr.rx]="rx"
    fill="url(#paint0_linear_1102_1919)"
    stroke="#FEFEFE"
    stroke-width="3"
  />
  <rect
    opacity="0.2"
    x="7"
    y="43"
    width="51"
    height="5"
    rx="2.5"
    fill="#969696"
  />
  <rect
    x="7"
    y="43"
    width="23"
    height="5"
    rx="2.5"
    fill="url(#paint1_linear_1102_1919)"
  />
  <rect
    opacity="0.2"
    x="7"
    y="35"
    width="51"
    height="5"
    rx="2.5"
    fill="#969696"
  />
  <rect
    x="7"
    y="35"
    width="36"
    height="5"
    rx="2.5"
    fill="url(#paint2_linear_1102_1919)"
  />
  <rect
    opacity="0.2"
    x="7"
    y="51"
    width="51"
    height="5"
    rx="2.5"
    fill="#969696"
  />
  <rect
    x="25"
    y="51"
    width="23"
    height="5"
    rx="2.5"
    fill="url(#paint3_linear_1102_1919)"
  />
  <path
    d="M29.9343 11.1231C30.4271 9.62565 32.5729 9.62565 33.0657 11.1231L34.1798 14.5079C34.4002 15.1776 35.0323 15.6309 35.7455 15.6309H39.3505C40.9454 15.6309 41.6085 17.6457 40.3182 18.5712L37.4017 20.6631C36.8247 21.077 36.5832 21.8106 36.8036 22.4802L37.9176 25.8651C38.4105 27.3625 36.6745 28.6077 35.3842 27.6822L32.4677 25.5903C31.8907 25.1764 31.1093 25.1764 30.5323 25.5903L27.6158 27.6822C26.3255 28.6077 24.5895 27.3625 25.0824 25.8651L26.1964 22.4802C26.4168 21.8106 26.1753 21.077 25.5983 20.6631L22.6818 18.5712C21.3916 17.6457 22.0546 15.6309 23.6495 15.6309H27.2545C27.9677 15.6309 28.5998 15.1776 28.8202 14.5079L29.9343 11.1231Z"
    fill="url(#paint4_linear_1102_1919)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1102_1919"
      x1="37.5"
      y1="64.0004"
      x2="-64.6232"
      y2="47.3419"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="#EBECF7"
      />
    </linearGradient>
    <linearGradient
      id="paint1_linear_1102_1919"
      x1="29.7125"
      y1="45.625"
      x2="29.6808"
      y2="49.8451"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint2_linear_1102_1919"
      x1="42.55"
      y1="37.625"
      x2="42.5297"
      y2="41.8452"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint3_linear_1102_1919"
      x1="47.7125"
      y1="53.625"
      x2="47.6808"
      y2="57.8451"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint4_linear_1102_1919"
      x1="40.7625"
      y1="19.45"
      x2="40.2652"
      y2="34.6268"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
  </defs>
</svg>
